<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="storageItemLots"
    :indexNested="true"
    :hasTopMenu="hasTopMenu"
    :maskFields="maskFields"
    :disablePagination="true"
    :hasTableTitle="hasTableTitle"
    :hasDefaultPageTitle="false"
    :tableTitle="tableTitle"
    :containSearchBar="false"
  >   

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
// import New from "./new.vue";
// import Edit from "./edit.vue";
// import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      // tableHeaders: [],
      maskFields: [
        // { field: 'averageUnitPrice', mask: 'currency_10d' }, 
        // { field: 'purchaseQuantity', mask: 'number'},
        { field: 'packagingQuantity', mask: 'number'}, 
        { field: 'quantity', mask: 'number'},         
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
  },
  props: {
    storageItemLots: {
      type: Array,
      default: () => [],
    },
    storageItemsTotalPrice: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: true
    },
    hasTableTitle: {
      type: Boolean,
      default: false
    },
    hasTopMenu: {
      type: Boolean, 
      default: true,
    },
    tableTitle: {
      type: String
    },
    modelNameSingular: {
      type: String,
      default: "Lote"
    },
    modelNamePlural: {
      type: String,
      default: "Lotes"
    },
  },
  created() {
  },
  computed: {
    tableHeaders() {
      // if (this.objectType == "StorageItem") {
        return [
          { text: "Lote", align: "left", sortable: true, value: "newName" },
          { text: "Qtd. de Emb.", align: "left", sortable: true, value: "packagingQuantity" },
          { text: "Qtd.", align: "left", sortable: true, value: "quantity" },          
        ]
    },
  },
  methods: {    
  }
};
</script>

<style scoped></style>
